import React from 'react';
import { JobFormDataInput } from '@ecosconnect/core/src/types/jobFormData';
import { useHistory } from 'react-router-dom';
import useMode from '../../../hooks/useMode';
import AccordionItem from '../../Accordion/AccordionItem';
import { AssemblyInfo } from '@/components/Job/queries';
import { assemblyModelLabel } from './assemblyModelLabel';

const BackflowTestAssemblyValues: React.FC<{
  originalBackflowAssembly?: AssemblyInfo;
  backflowAssemblyId?: string | number;
  formAssembly?: AssemblyInfo;
  formData: JobFormDataInput;
}> = ({ originalBackflowAssembly, backflowAssemblyId, formAssembly }) => {
  const history = useHistory();
  const mode = useMode();

  if (!formAssembly) {
    return <></>;
  }

  return (
    <>
      {formAssembly.serialNumber && (
        <AccordionItem
          kind="link"
          label="Serial"
          oldValue={originalBackflowAssembly?.serialNumber}
          value={formAssembly.serialNumber}
          href={
            backflowAssemblyId
              ? `/${mode}/assemblies/${backflowAssemblyId}`
              : undefined
          }
        />
      )}
      {!formAssembly.serialNumber && (
        <AccordionItem
          label="Serial"
          oldValue={originalBackflowAssembly?.serialNumber}
          value={formAssembly.serialNumber}
        />
      )}
      <AccordionItem
        label="Model"
        oldValue={assemblyModelLabel(originalBackflowAssembly)}
        value={assemblyModelLabel(formAssembly)}
      />
      <AccordionItem
        label="Type"
        oldValue={originalBackflowAssembly?.type?.replace(/_/g, ' ')}
        value={formAssembly.type?.replace(/_/g, ' ')}
      />
      <AccordionItem
        label="Size"
        oldValue={
          originalBackflowAssembly
            ? originalBackflowAssembly?.size + '"'
            : undefined
        }
        value={formAssembly.size ? formAssembly.size + '"' : undefined}
      />
      <AccordionItem
        label="Location"
        oldValue={originalBackflowAssembly?.location}
        value={formAssembly.location}
      />
      {/* <AccordionItem
        label="Install Date"
        value={
          originalBackflowAssembly?.installDate &&
          !originalBackflowAssembly.installDate.startsWith('00')
            ? format(parseISO(originalBackflowAssembly.installDate), 'M/d/yyyy')
            : '-'
        }
      /> */}
    </>
  );
};

export default BackflowTestAssemblyValues;
